import { Box, Button, Text } from '@air/zephyr';
import Image from 'next/image';
import Link from 'next/link';

import { AgencyContainer } from '~/old-marketing/components/agency/AgencyContainer';
import { AuthRoutes } from '~/old-marketing/constants/Routes';

export const AgencyCallToActionSection = () => {
  return (
    <Box as="section" tx={{ zIndex: 1, position: 'relative', backgroundColor: 'macaw600', py: [96, 140] }}>
      <Box tx={{ zIndex: -1, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden' }}>
        <Image height={829} src="/assets/marketing/agency-form-background.svg" width={1440} />
      </Box>
      <AgencyContainer>
        <Box tx={{ maxWidth: 600, mx: 'auto', textAlign: ['left', 'center'] }}>
          <Text
            as="h2"
            tx={{
              mb: 16,
              color: 'pigeon025',
              fontFamily: 'Brice-SemiBoldSemiExpanded',
              fontSize: [28, 36],
              letterSpacing: '0.03em',
              lineHeight: 1.15,
            }}
          >
            Made by the team at Air
          </Text>
          <Text
            as="p"
            tx={{ mb: 40, color: 'white', textAlign: ['left', 'center'] }}
            variant={['text-ui-18', 'text-ui-20']}
          >
            Air is where creative process happens. Centralize your team&apos;s content in a workspace that&apos;s
            organized, searchable, versioned, and easy to share. Your first 5GB are on us!
          </Text>
          <Link href={AuthRoutes.signUp} passHref>
            <Button as="a" size="large">
              Sign up for free
            </Button>
          </Link>
        </Box>
      </AgencyContainer>
    </Box>
  );
};
